import { ViewMode } from '@core/enums';

export const initialPageContextState: PageContext = {
  documentCulture: '',
  siteId: 1,
  viewMode: ViewMode.Unknown,
  showOnlyPublishedProducts: true,
};

export const examplePageContextState: PageContext = {
  documentCulture: 'en-TT',
  siteId: 1,
  viewMode: ViewMode.LiveSite,
  showOnlyPublishedProducts: true,
};

export default function pageContextReducer(state: PageContext = initialPageContextState): PageContext {
  return {
    ...state,
  };
}
